export const routes = [
	{
		'title': 'دستور کار',
		'icon': 'mx-3 fa fa-plus-circle',
		'hidden': 'loggedOut',
		'module' : 'Work_Orders',
		'children': [
			{
				'title': 'لیست دستورکار',
				'icon': 'mx-3 fa fa-minus',
				'path': '/list/Work_Orders',
			},
			{
				'title': 'ایجاد دستورکار',
				'icon': 'mx-3 fa fa-minus',
				'path': '/dynamic/CreateWork_Orders',
			},

		]
	},
	{
		'title': 'لیست درخواست کالا',
		'icon': 'fa fa-building',
		'path': '/list/Product_Request',
		'hidden': 'loggedOut',
		'module' : 'Product_Request',
	},
	{
		'title': 'ایجاد مشتری',
		'icon': 'fa fa-building',
		'path': '/dynamic/CreateAccounts',
		'hidden': 'loggedOut',
		'module' : 'Accounts'
	}
]